<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g fill="#13A2E8" fill-rule="evenodd">
      <path
        d="M1.757 12.884H12.57c-.382-1.714-1.914-2.999-3.74-2.999H5.496c-1.826 0-3.359 1.285-3.74 2.999zm11.737 1.665H.833c-.46 0-.833-.373-.833-.831C0 10.686 2.466 8.22 5.497 8.22H8.83c3.032 0 5.498 2.466 5.498 5.498 0 .458-.373.831-.833.831zM7.163 1.666c-1.102 0-1.999.896-1.999 1.999 0 1.104.897 2 2 2 1.102 0 1.998-.896 1.998-2 0-1.103-.896-2-1.999-2zm0 5.665c-2.02 0-3.665-1.645-3.665-3.666C3.498 1.645 5.142 0 7.163 0s3.665 1.645 3.665 3.665c0 2.021-1.644 3.666-3.665 3.666z"
        transform="translate(.667 .667)"
      />
    </g>
  </svg>
</template>